/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import SignupMainDumb from './SignupMainDumb';
import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  token: getAuthenticationToken(state),
});

export default compose(connect(mapStateToProps))(SignupMainDumb);
